var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJobTitle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7321_9325",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7321_9325)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.37167 14.1667C3.03489 14.1667 2.74984 14.05 2.5165 13.8167C2.28317 13.5833 2.1665 13.2983 2.1665 12.9615V6.0385C2.1665 5.70172 2.28317 5.41667 2.5165 5.18333C2.74984 4.95 3.03489 4.83333 3.37167 4.83333H6.1665V3.70517C6.1665 3.36839 6.28317 3.08333 6.5165 2.85C6.74984 2.61667 7.03489 2.5 7.37167 2.5H9.628C9.96478 2.5 10.2498 2.61667 10.4832 2.85C10.7165 3.08333 10.8332 3.36839 10.8332 3.70517V4.83333H13.628C13.9648 4.83333 14.2498 4.95 14.4832 5.18333C14.7165 5.41667 14.8332 5.70172 14.8332 6.0385V12.9615C14.8332 13.2983 14.7165 13.5833 14.4832 13.8167C14.2498 14.05 13.9648 14.1667 13.628 14.1667H3.37167ZM3.37167 13.1667H13.628C13.6793 13.1667 13.7263 13.1453 13.769 13.1025C13.8118 13.0598 13.8332 13.0128 13.8332 12.9615V6.0385C13.8332 5.98717 13.8118 5.94017 13.769 5.8975C13.7263 5.85472 13.6793 5.83333 13.628 5.83333H3.37167C3.32034 5.83333 3.27334 5.85472 3.23067 5.8975C3.18789 5.94017 3.1665 5.98717 3.1665 6.0385V12.9615C3.1665 13.0128 3.18789 13.0598 3.23067 13.1025C3.27334 13.1453 3.32034 13.1667 3.37167 13.1667ZM7.1665 4.83333H9.83317V3.70517C9.83317 3.65383 9.81178 3.60683 9.769 3.56417C9.72634 3.52139 9.67934 3.5 9.628 3.5H7.37167C7.32034 3.5 7.27334 3.52139 7.23067 3.56417C7.18789 3.60683 7.1665 3.65383 7.1665 3.70517V4.83333Z",
    fill: "#666666"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobTitle);
export default __webpack_public_path__ + "static/media/jobTitle.2a497e55210600fa0ff178132afeb428.svg";
export { ForwardRef as ReactComponent };